module.exports = __webpack_public_path__ + "media/control_acceso/seccional-d05806ad.png";